export default {
  logosrow: {
    statement: "Get your reverse mortgage from the best lender"
  },
  benefits: {
    statement:
      "Get you the best mortgage deal possible for the most important financial decision of your life",
    best_rates: "BEST RATES",
    best_rates_point:
      "Offering you complete transparency on rates available. Compare rates from 2,000+ mortgage products.",
    expert_advice: "EXPERT ADVICE",
    expert_advice_point:
      "Empowering you to select the best mortgage possible - our independent Mortgage Brokers work for you, not the bank.",
    seamless_process: "SEAMLESS PROCESS",
    seamless_process_point:
      "Taking care of the complexity of the application, so you don’t have to. Our smart technology takes the stress out of the process.",
    title: "Our Mission"
  },
  whocanapply: {
    title: "Who can apply?",
    factors: [
      'Homeowner in Ontario, Alberta or British Columbia',
      'Minimum proprety value of $250,000',
      'At least 55 years old',
      'Access up to $800,000 of tax free cash'
    ]
  },
  howitworks: {
    title: "How do I access the money?",
    step1: {
      title: "Second Opinions",
      description: "The PATH Home Plan can help you reimagine or maintain your lifestyle. As with all major financial decisions, it's important that you consult your financial advisor and/or discuss it with your family to get a few opinions first.",
      benefit1:
        "Get a complete overview of mortgage rates available – based on the information you input",
      benefit2:
        "Access accurate and transparent mortgage rate quotes from the most competitive financial institutions",
      benefit3:
        "Avoid hours of online research, phone calls, and branch visits",
      perk1: "2 minutes",
      perk2: "At your convenience",
      perk3: "24/7",
      cta: "GET STARTED"
    },
    step2: {
      title: "Set up a Meeting with a Mortgage Broker",
      description: "Wondering how changing interest rates and house appreciation will affect you? Have a few questions you'd like to ask? A mortgage broker can help with that. Mortgage professionals can research and recommend a solution for you based on your current situation and long term goals. Contact us.",
      benefit1:
        "Get an unbiased opinion from our Mortgage Brokers - they work for you, not the banks",
      benefit2:
        "Get informed - we translate mortgage products into plain English so you can make a sound decision",
      benefit3:
        "Get support on your own terms - as little or as much as you need",
      benefit4: "All our support is completely free",
      perk1: "15 minutes",
      perk2: "At your convenience",
      perk3: "9am - 8pm",
      perk4: "Phone or Chat"
    },
    step3: {
      title: "Preparing Your Documents",
      description: "",
      benefit1: "Proof you received independent",
      benefit2: "If you have debt secured through your residence, you'll need to provide supporting documents to confirm the details, example: Mortgage Statement.",
      benefit3: "Verification of your ability to cover property-related expenses such as property taxes, condominium fees and utilities",
      benefit4: "A home appraisal",
      benefit5: "A Power of Attorney (if applicable)",
      perk1: "Fastest turnaround",
      perk2: "Mortgage Broker led",
      perk3: "Status available 24-7",
      legalRollover:
        `Independent legal advice from your own lawyer to ensure this product is suitable for you.`,
      legalRolloverLink:
        "legal advice"
    },
    step4: {
      title: "Get Your Home Appraised",
      description: "An accredited home appraiser will help determine a fair market value. They will look at the condition of your home, current market trends, as well as other factors."
    },
    step5: {
      title: "Protect Your Interests",
      description: "Obtaining independant legal advice is one of the best ways to protect your interests and give you confidence to enter the agreement."
    }
  },
  meet: {
    title: "Meet the team",
    description: "Description...",
    subtitle: "Independent Mortgage Brokers working in your best interest",
    statement:
      "True independence means that we’ll present you all the mortgage products available, not just the ones that give most commission. We’ll tell you how much the lender makes, and what’s in it for us.",
    perk1: "45+ years of combined experience as licensed Mortgage Brokers",
    perk2: "Our Brokers rank among the top Mortgage Brokers in Canada",
    perk3:
      "We’ve helped thousands of Canadians achieve their dream of home ownership & mortgage freedom"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/en/landing.js